<template>
  <v-card class="mx-auto">
    <v-list-item two-line class="text-center">
      <v-list-item-content class="pb-0">
        <v-list-item-title class="text-h5">
          {{ title }}
        </v-list-item-title>
        <v-list-item-subtitle>{{ subtitle }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-text class="text-center pt-0">
      <v-progress-circular
        v-if="loading"
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
      <span class="text-h2" v-else>
        {{ dataPoint }}
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
    },
    dataPoint: {
      type: [String, Number],
      required: false,
      default: '----'
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
}
</script>
